import HttpService from './http-service';
import { SERVER_URL } from '../constants/api';
import cookieStorage from './cookie-storage';

const getAuthHeader = () => ({
  headers: {
    Authorization: cookieStorage.getCookie('Authorization'),
    'Content-Type': 'application/json'
  }
});

class VideoApiService {
  // Get video details
  static async getVideo(videoId) {
    const config = getAuthHeader();
    return HttpService.get(`${SERVER_URL}/video/${videoId}`, config);
  }

  // Get related videos
  static async getRelatedVideos(videoId, limit = 10) {
    const config = getAuthHeader();
    return HttpService.get(`${SERVER_URL}/videos/related?videoId=${videoId}&limit=${limit}`, config);
  }

  // Track video view
  static async trackView(videoId, studioId) {
    const config = getAuthHeader();
    const url = `${SERVER_URL}/studio/${studioId}/video/${videoId}/view`;
    console.log('[VideoApiService.trackView] Making request to:', url);
    
    try {
      // Backend expects PUT request with studioId in path
      const response = await HttpService.put(url, {}, config);
      console.log('[VideoApiService.trackView] Response:', response);
      return response;
    } catch (error) {
      console.error('[VideoApiService.trackView] Error:', error.response || error);
      throw error;
    }
  }

  // Like video
  static async likeVideo(videoId) {
    const config = getAuthHeader();
    return HttpService.post(`${SERVER_URL}/video/${videoId}/like`, {}, config);
  }

  // Unlike video
  static async unlikeVideo(videoId) {
    const config = getAuthHeader();
    return HttpService.post(`${SERVER_URL}/video/${videoId}/unlike`, {}, config);
  }

  // Get video comments
  static async getComments(videoId, page = 1, limit = 20) {
    const config = getAuthHeader();
    return HttpService.get(`${SERVER_URL}/studio/video/${videoId}/comments?page=${page}&limit=${limit}`, config);
  }

  // Post comment
  static async postComment(videoId, text) {
    const config = getAuthHeader();
    return HttpService.post(`${SERVER_URL}/studio/video/${videoId}/comments`, { content: text }, config);
  }

  // Edit comment
  static async editComment(commentId, text) {
    const config = getAuthHeader();
    return HttpService.put(`${SERVER_URL}/studio/video/comments/${commentId}`, { content: text }, config);
  }

  // Delete comment
  static async deleteComment(commentId) {
    const config = getAuthHeader();
    return HttpService.delete(`${SERVER_URL}/studio/video/comments/${commentId}`, config);
  }

  // Like comment
  static async likeComment(commentId) {
    const config = getAuthHeader();
    return HttpService.post(`${SERVER_URL}/studio/video/comments/${commentId}/like`, {}, config);
  }

  // Unlike comment (same as like - backend toggles)
  static async unlikeComment(commentId) {
    const config = getAuthHeader();
    return HttpService.post(`${SERVER_URL}/studio/video/comments/${commentId}/like`, {}, config);
  }
}

export default VideoApiService;